const s = require("./timePicker.module.scss");

import { default as React, useState } from "react";
import classnames from "classnames";
import { ApplicationState } from "core/app";

export interface TimePickerItem {
    date: Date;
    text: string;
}
interface Props {
    selectedDate: Date;
    dateSteps: string;

    applicationState: ApplicationState;
}

interface DispatchProps {
    onChange: (date: Date) => void;
}
interface State {
    open: boolean;
}

const TimePicker = ({ applicationState, dateSteps, selectedDate, onChange }: Props & DispatchProps) => {
    const enabled = dateSteps.startsWith("H");
    const initialState: State = { open: false };
    const [state, setState] = useState(initialState);
    const availableHours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24]
        .filter(hour => dateSteps == "H" //no filter, all 24 hours
            || (dateSteps == "H16+" && hour >= 16)
            || (dateSteps == "H12+" && hour >= 12)
        )
    const [isCnecInfo, setIsCnecInfo] = useState(false);
    const cnecDisabledBefore = new Date(selectedDate).setHours(16, 0, 0);

    const interceptEvent = (event: any) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
    };

    const renderListItem = (item: TimePickerItem) => {
        // XXX: LIQ-341: IBWT Cnec info grey out hours before 16:00, 17:00
        const isHourDisabled = !availableHours.includes(item.date.getHours());
        const className = classnames(s.dropdownitem
            , selectedDate.toUTCString() === item.date.toUTCString() ? s.selected : s.notselected
            , isHourDisabled ? "text-disabled" : "");
        return (<a key={item.text} className={className} onClick={(e) => !isHourDisabled && handleChange(e, item)} onMouseDown={handleMouseDown} onBlur={handleBlur} href="#">
            {item.text}
        </a>);
    };
    const handleChange = (event: any, item: TimePickerItem) => {
        clickedOnOption = false;
        interceptEvent(event);
        onChange(item.date);
        setState({ open: false });
    };
    const handleClose = (event: any) => {
        interceptEvent(event);
        if (!clickedOnOption) {
            setState({ open: false });
        }
        clickedOnOption = false;
    };
    let clickedOnOption: Boolean = false;
    let blurTimeout: any = undefined;
    const handleBlur = () => {
        clearTimeout(blurTimeout);
        blurTimeout = setTimeout(handleClose, 0);
    };
    const toggleOpenClose = (event: any) => {
        interceptEvent(event);
        setState({ open: !state.open });
        if (state.open) {
            return setState({ open: false });
        }
    };
    const handleMouseDown = () => {
        clickedOnOption = true;
    };

    React.useEffect(() => {
        if (availableHours.length > 0 && !availableHours.includes(selectedDate.getHours())) {
            onChange(new Date(selectedDate.setHours(availableHours[0], 0, 0)));
        }
    }, [selectedDate, availableHours]);

    const classNameInput = classnames(s.textField, "inputBorder", enabled ? s.enabled : s.disabled);
    const classNameDropDown = classnames(s.dropdownmenu, state.open ? "" : s.hidden);

    const rootDate = applicationState.setCweTimeForDate(applicationState.getCweTimeForDisplayPurposes(selectedDate), 0, 0); //CWE Time 00:00

    const getTwoDigits = (val: number) => (val > 9 ? "" : "0") + val;
    const dayLightSaveCheck = (utcDate: Date, localCweDateForDisplay: Date) => {
        if (localCweDateForDisplay.getHours() !== 2) return "";
        return (applicationState.getCweTimeForDisplayPurposes(new Date(new Date(utcDate).setUTCHours(utcDate.getUTCHours() - 1))).getHours() === 2) ? "+" : "";
    }
    const getHourRange = (date: Date) => {
        var localCweDate = applicationState.getCweTimeForDisplayPurposes(date);
        var dst = dayLightSaveCheck(date, localCweDate);
        return dst + getTwoDigits(localCweDate.getHours()) + ":00" + " - " + getTwoDigits(localCweDate.getHours() + 1) + ":00" + dst;
    }
    const loadAllHours = () => {
        const list: TimePickerItem[] = [];
        let newDate = rootDate;
        let i = 1;
        while (applicationState.getCweTimeForDisplayPurposes(newDate).getDay() === applicationState.getCweTimeForDisplayPurposes(rootDate).getDay()) {
            list.push({ date: newDate, text: getHourRange(newDate) });
            newDate = new Date(new Date(rootDate).setUTCHours(rootDate.getUTCHours() + i++));
            if (i > 30) { throw Error("There is an issue with the TimePicker"); }
        }
        return list;
    };

    return (<div>
        <button className={classNameInput} onClick={toggleOpenClose} onBlur={handleBlur}>
            {getHourRange(selectedDate)}
        </button>

        <div className={classNameDropDown}>
            {
                loadAllHours().map(renderListItem)
            }
        </div>
    </div>);
}

export default TimePicker;